export class ViewerParameters {
  public earth: PlanetParameters;
  public mars: PlanetParameters;

  public observationDay: number = 100;
  public initialMissionTime: number = 6904.95304398148;
  public nominalDownFrequency: number = 8.40413 * 10^9;
  public lightSpeed: number = 300000000;
  public graphTimeframe: number = 17.153086;
  public graphLongTimeframe: number = 40;
}

export class PlanetParameters {
  public majorSemiAxis: any;
  public excentricity: any;
  public revolutionPeriod: any;
  public averageMovement: any;
  public initialAnomaly: any;
  public initialPhase: any;
}
